import { render, staticRenderFns } from "./CollapsableMenu.vue?vue&type=template&id=698bf938&scoped=true&"
import script from "./CollapsableMenu.vue?vue&type=script&lang=ts&"
export * from "./CollapsableMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsableMenu.vue?vue&type=style&index=0&id=698bf938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698bf938",
  null
  
)

component.options.__file = "CollapsableMenu.vue"
export default component.exports